import React from 'react';
import { tokens } from '../theme';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helper?: string;
  error?: string;
  required?: boolean;
}

export function Input({ label, helper, error, required, style, ...rest }: Props) {
  const id = rest.id ?? rest.name;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {label && (
        <label
          htmlFor={id}
          style={{ fontSize: 13, fontWeight: 500, color: tokens.color.ink[700] }}
        >
          {label}
          {required && (
            <span style={{ color: tokens.color.accent.rust, marginLeft: 4 }}>*</span>
          )}
        </label>
      )}
      <input
        {...rest}
        id={id}
        aria-invalid={error ? 'true' : undefined}
        style={{
          height: 40,
          padding: '0 14px',
          fontSize: 15,
          background: tokens.color.paper['00'],
          color: tokens.color.ink[900],
          border: `1px solid ${error ? tokens.color.accent.rust : tokens.color.line[100]}`,
          borderRadius: tokens.radius.base,
          outline: 'none',
          ...style,
        }}
      />
      {helper && !error && (
        <span style={{ fontSize: 12, color: tokens.color.ink[500] }}>{helper}</span>
      )}
      {error && (
        <span role="alert" style={{ fontSize: 12, color: tokens.color.accent.rust }}>
          {error}
        </span>
      )}
    </div>
  );
}
